import { axiosInstanceAI } from ".";
import { toastNotify } from "../utils/Utils";

axiosInstanceAI.interceptors.response.use(
  (response) => {
    const error = response?.data?.err;
    const message = response?.data?.msg;

    if (typeof error === "boolean" && error === true) {
      if (typeof message === "string") {
        return Promise.reject(new Error(message));
      }
      if (typeof message === "object") {
        return Promise.reject(new Error(message.map().join(", ")));
      }
    }

    toastNotify(message, "success");
    return response;
  },
  (error) => {
    // Tangani kesalahan response di sini
    const status = error?.response?.status;
    const code = error?.code;
    let errorMessage = error;

    switch (status) {
      case 400:
      case 422:
        errorMessage = "Please check your request.";
        break;
      case 401:
      case 403:
        errorMessage = "Your session has expired, please log in again.";
        break;
      case 404:
        errorMessage = "The requested action was not found.";
        break;
      case 500:
        errorMessage = "Server error. Please try again later.";
        break;
      case 502:
      case 503:
      case 504:
        errorMessage = "The server is currently unavailable.";
        break;
      default:
        break;
    }

    switch (code) {
      case "ECONNABORTED":
      case "ERR_NETWORK":
        errorMessage = "Your connection is either slow or experiencing issues.";
        break;
      default:
        break;
    }

    return toastNotify(errorMessage, "error");
  },
);

export const requestAiGet = (url, config) => axiosInstanceAI.get(url, config);
export const requestAiPost = (url, data, config) =>
  axiosInstanceAI.post(url, data, config);

export default axiosInstanceAI;
